import styled, { css } from 'styled-components';
import { px2rem } from '../utils/helpers/style.js';
import { styles } from '../constants/styles.js';

var dot = /*#__PURE__*/styled.span.withConfig({
  displayName: "styles__dot",
  componentId: "sc-1boclke-0"
})(["", " cursor:", ";display:flex;justify-content:center;align-items:center;&:before{", " content:'';border-radius:100%;background-color:", ";transition:background-color ", ";transition-timing-function:", ";", "}"], function (props) {
  var activeSize = px2rem(props.$activeSize);
  var inactiveSize = px2rem(props.$size);
  var smallGap = px2rem(2);
  var largeGap = px2rem(8);
  if (props.$current) {
    return css(["height:", ";width:", ";"], "calc(".concat(activeSize, " + ").concat(props.$vertical ? largeGap : smallGap, ")"), "calc(".concat(activeSize, " + ").concat(props.$vertical ? smallGap : largeGap, ")"));
  } else {
    return css(["height:", ";width:", ";"], "calc(".concat(inactiveSize, " + ").concat(props.$vertical ? largeGap : smallGap, ")"), "calc(".concat(inactiveSize, " + ").concat(props.$vertical ? smallGap : largeGap, ")"));
  }
}, function (props) {
  return props.$controlled ? 'pointer' : 'initial';
}, function (props) {
  if (props.$current) {
    return css(["height:", ";width:", ";"], px2rem(props.$activeSize), px2rem(props.$activeSize));
  } else {
    return css(["height:", ";width:", ";"], px2rem(props.$size), px2rem(props.$size));
  }
}, function (props) {
  return props.$inactiveColor;
}, styles.transition.timing.slowest, styles.transition["function"].base, function (props) {
  if (props.$active) {
    return css(["background-color:", ";"], function (props) {
      return props.$activeColor;
    });
  }
});

export { dot };
